
import { Product } from "@/types/product";

export const btAC1: Product = {
  id: "bt-ac1",
  groupId: "avoip",
  name: "BT-AC1",
  subtitle: "Audio Control Module",
  description: "The BT-AC1 is a Bluetooth™ Auracast USB Dongle accessory for the VPX AV over IP Series. It can broadcast the audio signal up to 100 meters. It is designed to work with Bluetooth 5.2 and higher devices like cell phones, ear buds, and hearing aids. Auracast is capable of broadcasting to thousands of devices making it perfect in restaurants, bars, airports, conference rooms and more. Picture sitting in a restaurant with many displays and being able to listen to the display of your choice with your own peripheral. Perfect for listening privacy, hearing assist, language translations, and more. Once again, Aurora is leading the way in industry firsts and further expanding the capabilities of AV over IP. For more information on Auracast please see here https://www.bluetooth.com/auracast/",
  features: [
    "Advanced audio processing",
    "Multiple input/output options",
    "Compatible with all VPX components",
    "Compact design"
  ],
  images: ["/lovable-uploads/41edd5ed-ec4e-4802-a7e7-8e3b18aacd6a.png"],
  slug: "bt-ac1",
  networkSpeed: "vpx-accessories"
};
